import { showNotificationToast } from 'shared/utils/notify'
import { getPrivySessionBridge } from '../session-bridge'

/* Toasts of the Privy → XYRO session exchange (FE-301). */

export const notifyExchangeFailed = (error: unknown) => {
  console.error('Privy session exchange failed', error)
  showNotificationToast({
    type: 'error',
    title: 'Sign in failed',
    description: 'Could not open your XYRO session. Please try again.'
  })
}

export const notifyAccountTaken = () =>
  showNotificationToast({
    type: 'error',
    title: 'Account already exists',
    description:
      'This email or wallet belongs to another XYRO account. Sign in with that account instead.'
  })

export const notifyNameTaken = () =>
  showNotificationToast({
    type: 'warning',
    title: 'This name is already taken',
    description: 'Pick another nickname.'
  })

export const notifySessionExpired = () =>
  showNotificationToast({
    type: 'warning',
    title: 'Session expired',
    description: 'Please sign in again.',
    actionText: 'Sign in',
    buttonAction: () => getPrivySessionBridge()?.login()
  })
